import React from 'react'
import { ServerConfig } from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'


const Machines = () => {
    const non_editable_fields = []

    const editable_fields = [
      ["id", "ID"],
    ["name", "Name"],
    ["cert_id", "Cert-ID"],
    ["dc_id", "DC-ID"],
    ["tenant_site_id", "Tenant Site ID", "tenantsite"],
    ["url", "URL"],
    ["port", "port"],
    ["owner", "Owner", "tenant"],
    ["devicetype", "Device Type", "devicetype"],
    ["secret", "Secret"],
    ["operationtype_id", "Operation Type", "operationtype"],
    ["allow_cash_payout", "Cash Payout", "boolean"],
    ["printer_id", "Printer ID"]
  ];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/admin/machines`}
        detail_get_url={`${ServerConfig.SERVER_URL}/admin/machines/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/admin/machines/`}
        add_new_url = {`${ServerConfig.SERVER_URL}/admin/machines/add`}

        column_names={["online", "devicetype", "operationtype_name", "allow_cash_payout_str", "name",  "secret", "edit"]}
        header_names={["Online?", "Type", "Operation Type", "Cash payout?", "Name", "Secret", ""]}

        optional_column_names={["tenant_site_id", "cert_id", "secret", "owner_name"]}
        optional_header_names={["Site ID", "Cert ID", "secret", "Owner"]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        //ledger_get_url = '/ledger/customer/'
        show_machine_stats={true}
      />
    </>
  )
}

export default Machines
